module.exports = __webpack_public_path__ + "static/media/2016-Mustang-Convertible-V6.7f143bcf.jpg";